import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ASIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AS" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#3547A0"
        stroke="#E31D1C"
        d="m16-.5.176.968L1.423 6l14.753 5.532L16 12.5H-.5V6.346L-1.424 6l.924-.347V-.5H16Z"
      />
      <Path
        fill="#C44800"
        fillRule="evenodd"
        d="M14.045 3.014s-4.032 1.046-4.032 1.208c0 .16-.363.67-.288.804.074.133.267.31.425.222.159-.089.535-.443.409-.222-.127.222.679.48.34.968 0 0 .407-.235.21 1.102l.97.277s1.085-.284.59-1.098h.574s-.238-1.054.114-1.249c.352-.194-.358-.342-.358-.342 1.502-.856 1.046-1.67 1.046-1.67Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FFC221"
        fillRule="evenodd"
        d="m13.377 7.485-2.433-.411-.32-.427-1.38.278 1.212.688.408-.22 2.513.401v-.309Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FFC221"
        fillRule="evenodd"
        d="M13.751 7.86v-.242l-2.728-.166s-.165-.152-.57-.152c-.407 0-.453.318-.453.318s.233.464.684.464c.451 0 1.153.109 1.343.332.19.223.978-.115.978-.115s-.337-.579-.769-.398c-.431.181-1.213-.087-1.213-.185s2.728.143 2.728.143ZM9.143 5.907s-.265.567-.169.782c.423.44 1.19-.262 1.19-.262l-1.021-.52Z"
        clipRule="evenodd"
      />
      <Path
        fill="#979797"
        d="M13.533 4.618V4.8c.14.136.205.348.205.616 0 .35-.144.616-.424.76l-.175.02c-1.127-.28-2.223-.14-3.3.423l-.222.005c-.497-.23-.53-.705-.164-1.26.363-.55 1.612-.77 3.831-.75l.248.003Zm-.25.248c-2.121-.02-3.328.192-3.62.635-.293.444-.273.743.06.897 1.13-.59 2.29-.737 3.476-.442.193-.1.289-.279.289-.539s-.069-.423-.205-.489v-.062Z"
      />
      <Path
        fill="#F7FCFF"
        d="M13.282 4.865c-2.12-.019-3.327.193-3.62.637-.292.443-.272.742.06.896 1.132-.59 2.29-.738 3.477-.443.193-.099.289-.278.289-.538s-.069-.423-.206-.488v-.064Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
